import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MaterialModule } from '../../material-module';
import { LoadingDialog } from './loading.dialog';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule
  ],
  declarations: [LoadingDialog],
  exports: [LoadingDialog]
})
export class LoadingDialogModule { }
